<template>
    <div class="w-full h-screen relative overflow-hidden">
        <!-- alert -->
    <div :class="erreurAlert ? 'translate-x-0':'translate-x-[120%]'" :style="`max-width: ${widthMessage}px;`" class="transition duration-1000 absolute top-[5rem] right-1 md:right-2 z-50 flex md:block justify-center">
        <div class=" w-full md:w-full px-1 space-x-1 py-3 h-16 flex items-center justify-center bg-red-500  rounded-md z-50">
          <svg class="h-6 flex-shrink-0 object-contain" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 208 208" version="1.1">
              <g id="surface1">
                  <path style=" stroke:none;fill-rule:nonzero;fill:#FFFFFF;fill-opacity:1;"
                      d="M 199.246094 158.621094 L 120.027344 21.421875 C 110.332031 4.648438 94.515625 4.648438 84.820313 21.421875 L 5.601563 158.621094 C -4.09375 175.394531 3.847656 189.089844 23.207031 189.089844 L 181.644531 189.089844 C 201 189.089844 208.910156 175.394531 199.246094 158.621094 Z M 91.53125 60.351563 C 94.390625 57.273438 97.992188 55.734375 102.425781 55.734375 C 106.855469 55.734375 110.457031 57.246094 113.320313 60.292969 C 116.121094 63.308594 117.566406 67.125 117.566406 71.710938 C 117.566406 75.617188 111.65625 104.546875 109.6875 125.566406 L 95.4375 125.566406 C 93.714844 104.546875 87.28125 75.617188 87.28125 71.710938 C 87.28125 67.183594 88.730469 63.398438 91.53125 60.351563 Z M 113.105469 160.375 C 110.117188 163.269531 106.546875 164.746094 102.425781 164.746094 C 98.300781 164.746094 94.730469 163.269531 91.746094 160.375 C 88.757813 157.453125 87.28125 153.945313 87.28125 149.789063 C 87.28125 145.664063 88.757813 142.09375 91.746094 139.109375 C 94.730469 136.125 98.300781 134.648438 102.425781 134.648438 C 106.546875 134.648438 110.117188 136.125 113.105469 139.109375 C 116.089844 142.09375 117.566406 145.664063 117.566406 149.789063 C 117.566406 153.945313 116.089844 157.453125 113.105469 160.375 Z " />
              </g>
          </svg>
          <div class="text-white w-max text-center first-letter:uppercase">{{ messageErreurAlert }}</div>
        </div>
      </div>
  
       <!-- success -->
      <div :class="successAlert ? 'translate-x-0':'translate-x-[140%]'" :style="`max-width: ${widthMessage}px;`" class="transition duration-1000 absolute top-[5rem] right-1 md:right-2 z-50 flex md:block justify-center">
        <div class=" w-full md:w-full px-1 py-3 space-x-1 h-16 flex items-center justify-center bg-green-500  rounded-md z-50">
          <img class="h-8 flex-shrink-0 object-contain" src="/icons/checkwhite.png" alt="" srcset="">
          <div class="text-white w-max text-center first-letter:uppercase">{{ messageSuccessAlert }}</div>
        </div>
      </div>
        <div v-if="hidEnterEmailCode" class="w-full h-screen flex items-center absolute backdrop-blur-sm z-50">
            <div class="w-full h-screen flex">
                <div class="w-full h-full flex items-center">
                    <div class=" w-full h-full relative">
                        <div class="w-full flex absolute">
                            <div
                                class="  xl:w-[25%]  lg:w-[45%] md:w-[50%] w-[90%] mx-auto h-auto relative rounded-xl z-50">
                                <!--Formulaire-->
                                <div
                                    class="w-full absolute rounded-xl z-10 bg-black  bg-opacity-80 py-2 transition-all duration-1000">
                                    <!--Titre-->
                                    <div class="w-full flex h-12 items-center">
                                        <p class=" text-white text-xl font-semibold mx-auto">{{ $t('emailboutique') }}</p>
                                    </div>
                                    <!--Email/code-->
                                    <form @submit.prevent="confirmEmail" action="">
                                        <div class="w-full mt-1 px-3">
                                            <!--code-->
                                            <div>
                                                <div class="relative w-full ">
                                                    <div
                                                        class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path
                                                                    style=" stroke:none;fill-rule:nonzero;fill:#666666;fill-opacity:1;"
                                                                    d="M 259 64 C 141.1875 62.25 46.625 167.75 66.5 288.5 C 80 370.4375 147.25 434.875 229.5 446 C 284.9375 453.5 336.75 437.5 376 406 L 356 381 C 323.25 407.25 280.1875 420.8125 233.5 414.5 C 165.4375 405.3125 109.625 351.25 98.5 283.5 C 81.75 181.5625 159.875 94.5625 258.5 96 C 342.5625 97.25 413.4375 166.9375 416 251 C 416.0625 252.8125 416 254.5625 416 256.5 C 415.875 291.75 387.3125 320 352 320 C 334.125 320 320 305.875 320 288 L 320 160 L 288 160 L 288 172.5 C 276.5 164.6875 262.8125 160 248 160 C 208.4375 160 176 192.4375 176 232 L 176 280 C 176 319.5625 208.4375 352 248 352 C 269.5625 352 288.75 342.1875 302 327 C 313.75 341.9375 331.6875 352 352 352 C 404.5625 352 447.8125 309.125 448 256.5 C 448 254.375 448.0625 252.3125 448 250 C 444.9375 148.625 360.375 65.5 259 64 Z M 248 192 C 270.25 192 288 209.75 288 232 L 288 280 C 288 302.25 270.25 320 248 320 C 225.75 320 208 302.25 208 280 L 208 232 C 208 209.75 225.75 192 248 192 Z " />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <input v-model="formForget.email" type="email" id="input-group-1"
                                                        class="bg-[#181A20] border border-white text-gray-400 text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#FF9900] dark:focus:border-[#FF9900] focus:outline-none"
                                                        :placeholder="$t('email')">
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="loadConfirmeMail == false" class="w-full flex justify-center mt-2">
                                            <button
                                                class="px-3 py-2 bg-[#FF9900] text-white border-2 border-transparent hover:bg-transparent hover:text-[#FF9900] hover:border-[#FF9900] rounded-md">
                                                {{ $t('envoyer') }}
                                            </button>
                                        </div>
                                        <div v-if="loadConfirmeMail" class="
                                      px-3 py-2
                                      rounded-lg
                                      flex
                                      items-center
                                      justify-center
                                       text-white
                                       w-40
                                      mx-auto
                                      h-10
                                      text-center">
                                            <svg aria-hidden="true"
                                                class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="hidEnterEmailCode = false" class="w-full h-screen backdrop-blur-sm  flex fixed"></div>
            </div>
        </div>
        <div v-if="hidcode" class="w-full h-screen flex items-center absolute backdrop-blur-sm z-50">
            <div class="w-full h-screen flex">
                <div class="w-full h-full flex items-center">
                    <div class=" w-full h-full relative">
                        <div class="w-full flex absolute">
                            <div
                                class="  xl:w-[25%]  lg:w-[45%] md:w-[50%] w-[90%] mx-auto h-auto relative rounded-xl z-50">
                                <!--Formulaire-->
                                <div class="w-full absolute rounded-xl z-10 bg-black  bg-opacity-80 py-2">
                                    <!--Titre-->
                                    <div class="w-full flex h-12 items-center">
                                        <p class=" text-white text-xl font-semibold mx-auto">{{ $t('codeverification') }}
                                        </p>
                                    </div>
                                    <!--Email/code-->
                                    <form @submit.prevent="verifyCode" action="">
                                        <div class="w-full mt-1 px-3">
                                            <!--code-->
                                            <div>
                                                <div>
                                                    <p v-if="errorcode == 'incorrect'"
                                                        class="text-[#FF0000] w-full text-xs">{{ $t('errorcode') }}</p>
                                                    <p v-if="errorcode == 'code correct'"
                                                        class="text-green-500 w-full text-xs">{{ $t('codecorrectlogin') }}
                                                    </p>
                                                </div>
                                                <div class="relative w-full ">
                                                    <div
                                                        class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 208 208"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path
                                                                    style=" stroke:none;fill-rule:nonzero;fill:#959595;fill-opacity:1;"
                                                                    d="M 102.425781 0 C 76.234375 0 55.152344 21.082031 55.152344 47.273438 L 55.152344 78.789063 C 37.824219 78.789063 23.636719 92.976563 23.636719 110.304688 L 23.636719 173.332031 C 23.636719 190.660156 37.824219 204.847656 55.152344 204.847656 L 149.695313 204.847656 C 167.023438 204.847656 181.210938 190.660156 181.210938 173.332031 L 181.210938 110.304688 C 181.210938 92.976563 167.023438 78.789063 149.695313 78.789063 L 70.910156 78.789063 L 70.910156 47.273438 C 70.910156 29.328125 84.480469 15.757813 102.425781 15.757813 C 120.367188 15.757813 133.9375 29.328125 133.9375 47.273438 L 133.9375 55.152344 L 149.695313 55.152344 L 149.695313 47.273438 C 149.695313 21.082031 128.613281 0 102.425781 0 Z M 102.425781 118.183594 C 111.101563 118.183594 118.183594 125.261719 118.183594 133.9375 C 118.183594 139.449219 115.042969 144.863281 110.304688 147.234375 L 110.304688 165.453125 C 110.304688 170.195313 107.164063 173.332031 102.425781 173.332031 C 97.683594 173.332031 94.546875 170.195313 94.546875 165.453125 L 94.546875 147.234375 C 89.804688 144.863281 86.667969 139.449219 86.667969 133.9375 C 86.667969 125.261719 93.746094 118.183594 102.425781 118.183594 Z " />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <input :disabled="errorcode == 'code correct' ? true : false"
                                                        v-model="formForget.code" type="text" id="input-group-1"
                                                        class="bg-[#181A20] border border-white text-gray-400 text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#FF9900] dark:focus:border-[#FF9900] focus:outline-none"
                                                        :placeholder="$t('messagecode')">
                                                </div>
                                            </div>

                                        </div>
                                        <div v-if="loadingcode == false" class="w-full flex justify-center mt-2">
                                            <button
                                                class="px-3 py-2 bg-[#FF9900] text-white border-2 border-transparent hover:bg-transparent hover:text-[#FF9900] hover:border-[#FF9900] rounded-md">
                                                {{ $t('verifier') }}
                                            </button>
                                        </div>
                                        <div v-if="loadingcode" class="
                                      px-3 py-2
                                      rounded-lg
                                      flex
                                      items-center
                                      justify-center
                                       text-white
                                       w-40
                                      mx-auto
                                      h-10
                                      text-center">
                                            <svg aria-hidden="true"
                                                class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#37ff00]"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </div>
                                        <div v-if="loadingnewcode == false && valideSend == false" class="w-full mt-2 flex">
                                            <button @click="newCode" class="mx-auto underline text-xs text-[#FF9900]">{{
                                                $t('envoyeunnouveaucode') }}</button>
                                        </div>
                                        <div v-if="valideSend == true" class="w-full mt-2 flex">
                                            <p class="mx-auto text-xs text-green-500">{{ $t('validecodeenvoye') }}</p>
                                        </div>
                                        <div v-if="loadingnewcode == true && valideSend == false" class="
                                      rounded-lg
                                      flex
                                      items-center
                                      justify-center
                                       text-white
                                       w-40
                                      mx-auto
                                      h-10
                                      text-center">
                                            <svg aria-hidden="true"
                                                class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="hidcode = false" class="w-full h-screen backdrop-blur-sm  flex fixed"></div>
            </div>
        </div>
        <div v-if="HidEnterChangePassword" class="w-full h-screen flex items-center absolute backdrop-blur-sm z-50">
            <div class="w-full h-screen flex">
                <div class="w-full h-full flex items-center">
                    <div class=" w-full h-full relative">
                        <div class="w-full flex absolute">
                            <div
                                class="  xl:w-[25%]  lg:w-[45%] md:w-[50%] w-[90%] mx-auto h-auto relative rounded-xl z-50">
                                <!--Formulaire-->
                                <div class="w-full absolute rounded-xl z-10 bg-black bg-opacity-80 py-2">
                                    <!--Titre-->
                                    <div class="w-full flex h-12 items-center">
                                        <p class=" text-white text-xl font-semibold mx-auto">{{ $t('nouveaumotdepasse') }}
                                        </p>
                                    </div>
                                    <!--Email/code-->
                                    <form @submit.prevent="changePassword" action="">
                                        <div class="w-full mt-1 px-3">
                                            <!--code-->
                                            <div>
                                                <div class="relative w-full ">
                                                    <!--password-->
                                                    <div class="mt-4 w-full">
                                                        <div class="relative w-full">
                                                            <div class="
                                                    absolute
                                                    inset-y-0
                                                    left-0
                                                    flex
                                                    items-center
                                                    pointer-events-none
                                                  ">
                                                            </div>
                                                            <!--icone mot de passe masquer-->
                                                            <button type="button" @click="hidpassword = !hidpassword"
                                                                class="absolute inset-y-0 right-1 flex items-center pl-3">
                                                                <svg v-if="hidpassword == false" class="
                                                      w-[1.20rem]
                                                      h-[1.20rem]
                                                      text-gray-500
                                                      dark:text-gray-400
                                                    " xmlns="http://www.w3.org/2000/svg"
                                                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                                                    viewBox="0 0 512 512" version="1.1">
                                                                    <g id="surface1">
                                                                        <path style="
                                                          stroke: none;
                                                          fill-rule: nonzero;
                                                          fill: #959595;
                                                          fill-opacity: 1;
                                                        " d="M 59.5 36.5 L 36.5 59.5 L 136 158.5 L 313.5 336 L 344 367 L 452.5 475.5 L 475.5 452.5 L 376 353 C 443.75 319.4375 489.1875 269.625 492 266.5 L 501.5 256 L 492 245.5 C 487.6875 240.6875 385.375 128 256 128 C 224.6875 128 195.125 134.875 168 145 Z M 256 160 C 290.4375 160 323 169.6875 352 183 C 362.3125 200.25 368 219.75 368 240 C 368 269.0625 356.75 295.625 338.5 315.5 L 293 270 C 299.6875 261.8125 304 251.4375 304 240 C 304 213.5 282.5 192 256 192 C 244.5625 192 234.1875 196.3125 226 203 L 193.5 170.5 C 213.375 164.375 234.1875 160 256 160 Z M 107 174.5 C 55.6875 206.0625 22.375 242.8125 20 245.5 L 10.5 256 L 20 266.5 C 24.125 271.125 118.875 374.8125 241 383 C 245.9375 383.5 250.9375 384 256 384 C 261.0625 384 266.0625 383.5 271 383 C 284.1875 382.125 297.0625 380.375 309.5 377.5 L 281 349 C 272.875 350.875 264.625 352 256 352 C 194.25 352 144 301.75 144 240 C 144 231.5 145.125 223.1875 147 215 Z M 116 207 C 113.4375 217.8125 112 228.8125 112 240 C 112 267.8125 119.8125 293.4375 133.5 315.5 C 96.875 294.5 68.875 269.875 54.5 256 C 66.4375 244.4375 87.9375 225.25 116 207 Z M 396 207 C 424.0625 225.25 445.5 244.4375 457.5 256 C 443.125 269.875 414.6875 295 378 316 C 391.75 293.9375 400 267.8125 400 240 C 400 228.8125 398.5625 217.75 396 207 Z " />
                                                                    </g>
                                                                </svg>
                                                                <svg v-if="hidpassword == true" class="
                                                      w-[1.20rem]
                                                      h-[1.20rem]
                                                      text-gray-500
                                                      dark:text-gray-400
                                                    " xmlns="http://www.w3.org/2000/svg"
                                                                    xmlns:xlink="http://www.w3.org/1999/xlink" width="512pt"
                                                                    height="512pt" viewBox="0 0 512 512" version="1.1">
                                                                    <g id="surface1">
                                                                        <path
                                                                            style=" stroke:none;fill-rule:nonzero;fill:#959595;fill-opacity:1;"
                                                                            d="M 256 128 C 122.625 128 20 245.5 20 245.5 L 10.5 256 L 20 266.5 C 20 266.5 113.5625 373.1875 238 383 C 243.9375 383.75 249.875 384 256 384 C 262.125 384 268.0625 383.75 274 383 C 398.4375 373.1875 492 266.5 492 266.5 L 501.5 256 L 492 245.5 C 492 245.5 389.375 128 256 128 Z M 256 160 C 291.25 160 323.75 169.625 352 182.5 C 362.1875 199.375 368 218.8125 368 240 C 368 297.8125 324.625 345.3125 268.5 351.5 C 268.1875 351.5625 267.8125 351.4375 267.5 351.5 C 263.6875 351.6875 259.875 352 256 352 C 251.75 352 247.625 351.75 243.5 351.5 C 187.375 345.3125 144 297.8125 144 240 C 144 219.125 149.625 199.6875 159.5 183 L 159 183 C 187.5 169.875 220.375 160 256 160 Z M 256 192 C 229.5 192 208 213.5 208 240 C 208 266.5 229.5 288 256 288 C 282.5 288 304 266.5 304 240 C 304 213.5 282.5 192 256 192 Z M 116 207 C 113.5 217.75 112 228.5625 112 240 C 112 268.0625 120 294.3125 134 316.5 C 93.6875 293.1875 65.6875 265.375 56.5 256 C 64.1875 248.125 85.625 227.25 116 207 Z M 396 207 C 426.375 227.25 447.8125 248.125 455.5 256 C 446.3125 265.375 418.3125 293.1875 378 316.5 C 392 294.3125 400 268.0625 400 240 C 400 228.5625 398.5 217.625 396 207 Z " />
                                                                    </g>
                                                                </svg>
                                                            </button>
                                                            <input v-model="formNewPassword.password"
                                                                :type="hidpassword ? 'text' : 'password'" id="input-group-1"
                                                                class="bg-[#181A20] border border-white text-gray-400 text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#FF9900] dark:focus:border-[#FF9900] focus:outline-none"
                                                                :placeholder="$t('motdepasse')">
                                                        </div>
                                                    </div>
                                                    <!--confirme password-->
                                                    <div class="mt-4 w-full">
                                                        <div class="relative w-full">
                                                            <div class="
                                                    absolute
                                                    inset-y-0
                                                    left-0
                                                    flex
                                                    items-center
                                                    pointer-events-none
                                                  ">
                                                            </div>
                                                            <input v-model="formNewPassword.password_confirmation"
                                                                :type="hidpassword ? 'text' : 'password'" id="input-group-1"
                                                                class="bg-[#181A20] border border-white text-gray-400 text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-[#FF9900] dark:focus:border-[#FF9900] focus:outline-none"
                                                                :placeholder="$t('confirmemotdepasse')">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="loadingChangePassword == false" class="w-full flex justify-center mt-2">
                                            <button
                                                class="px-3 py-2 bg-[#FF9900] text-white border-2 border-transparent hover:bg-transparent hover:text-[#FF9900] hover:border-[#FF9900] rounded-md">
                                                {{ $t('envoyer') }}
                                            </button>
                                        </div>
                                        <div v-if="loadingChangePassword" class="
                                      px-3 py-2
                                      rounded-lg
                                      flex
                                      items-center
                                      justify-center
                                       text-white
                                       w-40
                                      mx-auto
                                      h-10
                                      text-center">
                                            <svg aria-hidden="true"
                                                class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="HidEnterChangePassword = false" class="w-full h-screen backdrop-blur-sm  flex fixed"></div>
            </div>
        </div>
        <div class="w-full h-screen flex items-center ">
            <div v-if="hidlangue == true"
                class="fixed top-10 right-6 z-50 w-[5.5rem] bg-gray-200 hover:bg-[#FF9900] xl:px-1">
                <button v-if="langue == 'fr'" @click='changeLangue()' type="button"
                    class=" flex items-center w-full h-full space-x-1 ">
                    <img class="w-6 h-6 " src="/icons/england_480px.png" alt="" srcset="">
                    <p class="mb-1">Anglais</p>
                </button>
                <button v-if="langue == 'en'" @click='changeLangue()' type="button"
                    class=" flex items-center w-full h-full space-x-1 ">
                    <img class="w-6 h-6 " src="/icons/france_480px.png" alt="" srcset="">
                    <p class="mb-1">Français</p>
                </button>
            </div>
            <div class="w-full h-screen flex">
                <div class="hidden md:block md:w-[40%] xl:w-[55%] h-full bg-[#FF9900] relative">
                    <div class="absolute w-full h-full z-10">
                        <div class="w-full h-full relative">
                            <div
                                class="md:w-[90%] 2xl:w-[35%] xl:w-[40%] h-full absolute md:right-0 xl:right-10 flex items-center">
                                <div class="w-full space-y-8">
                                    <div class="flex">
                                        <div class="h-auto flex items-center">
                                            <img class="h-20" src="/logo/logo_mel_completement_blanc.png" alt="" srcset="">
                                        </div>
                                        <div class="h-auto flex items-center">
                                            <p class="text-[4rem] font-bold ml-2 font-baskerville mt-[1.65rem]">M.E.L</p>
                                        </div>
                                    </div>
                                    <p id="slogan" class="text-3xl text-white ml-2 font-segoe">{{ convertTextInGras($t('slogan')) }}</p>
                                    <div class="w-full flex flex-wrap">
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img src="/images/photo_2023-11-11_12-19-54.jpg" alt=""
                                                srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center  rounded-md overflow-hidden">
                                            <img class="w-full object-contain object-center"
                                                src="/images/photo_2023-11-11_12-19-31.jpg" alt="" srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img class="w-full object-contain object-center"
                                                src="/images/photo_2023-11-11_12-20-00.jpg" alt="" srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img class="w-full object-contain object-center"
                                                src="/images/photo_2023-11-11_12-20-25.jpg" alt="" srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img class="w-full object-contain object-center"
                                                src="/images/photo_2023-11-11_12-20-32.jpg" alt="" srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img src="/images/photo_2023-11-11_12-20-39.jpg" alt=""
                                                srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img src="/images/photo_2023-11-11_12-20-51.jpg" alt=""
                                                srcset="">
                                        </div>
                                        <div
                                            class="w-14 h-14 bg-white ml-3 mt-3 flex items-center rounded-md overflow-hidden">
                                            <img src="/images/belle-sac-main-vert-elegance-mode-luxe.jpg" alt="" srcset="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full h-full relative">
                        <div
                            class="absolute md:w-full xl:w-[70%] 2xl:w-[70%] h-full bg-gradient-to-l from-[#FF9900] landscape:bg-gradient-to-l to-transparent">
                        </div>
                        <div class="flex justify-start h-full">
                            <img class=" h-full xl:object-contain md:object-cover object-center"
                                src="/logo/allicons.png" alt="" srcset="">
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-[60%] xl:w-[45%] h-full">
                    <div class="w-full flex items-center">
                        <div class="w-full justify-between flex px-6">
                            <router-link to="/" class="w-[10%]">
                                <img src="/logo/mel_logo_all_fond.png" class="w-full" />
                            </router-link>
                            <button v-if="langue == 'fr'" @click="showHidLangue" type="button"
                                class=" flex items-center space-x-1 ">
                                <img class="w-6 h-6 " src="/icons/france_480px.png" alt="" srcset="">
                                <p class="mb-1">Français</p>
                            </button>
                            <button v-if="langue == 'en'" @click="showHidLangue" type="button"
                                class=" flex items-center space-x-1 ">
                                <img class="w-6 h-6 " src="/icons/england_480px.png" alt="" srcset="">
                                <p class="mb-1">Anglais</p>
                            </button>
                        </div>
                    </div>
                    <div class="w-full h-[90%] flex items-center">
                        <div class="w-full">
                            <div class="w-full text-center">
                                <p class="text-[3rem] font-arial ">{{ $t('connecter') }}</p>
                                <p class="text-gray-500 text-[1rem]">{{ $t('messagelogin') }}</p>
                            </div>
                            <div class="w-full mt-8">
                                <form @submit.prevent="login" class="md:w-[60%] w-[90%] mx-auto ">
                                    <div class="w-full space-y-2">
                                        <div class="flex">
                                            <div>
                                                <label class="text-[0.75rem]">{{ $t('email') }}</label>
                                            </div>
                                        </div>

                                        <input v-model="form.email" required type="email" id="input-group-1"
                                            class=" bg-gray-200 border border-white  text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5   focus:outline-none"
                                            placeholder="ex: ekenfranky@gmail.com" />
                                    </div>

                                    <!--password-->
                                    <div class="mt-4 w-full">
                                        <div class="flex justify-between">
                                            <label class="text-[0.75rem]">{{ $t('motdepasse') }}</label>

                                        </div>
                                        <div class="relative w-full">
                                            <div class="
                            absolute
                            inset-y-0
                            left-0
                            flex
                            items-center
                            pl-3
                            pointer-events-none
                          ">
                                            </div>
                                            <!--icone mot de passe masquer-->
                                            <button type="button" @click="hidpassword = !hidpassword"
                                                class="absolute inset-y-0 right-1 flex items-center pl-3">
                                                <svg v-if="hidpassword == false" class="
                              w-[1.20rem]
                              h-[1.20rem]
                              text-gray-500
                              dark:text-gray-400
                            " xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 512 512" version="1.1">
                                                    <g id="surface1">
                                                        <path style="
                                  stroke: none;
                                  fill-rule: nonzero;
                                  fill: #959595;
                                  fill-opacity: 1;
                                " d="M 59.5 36.5 L 36.5 59.5 L 136 158.5 L 313.5 336 L 344 367 L 452.5 475.5 L 475.5 452.5 L 376 353 C 443.75 319.4375 489.1875 269.625 492 266.5 L 501.5 256 L 492 245.5 C 487.6875 240.6875 385.375 128 256 128 C 224.6875 128 195.125 134.875 168 145 Z M 256 160 C 290.4375 160 323 169.6875 352 183 C 362.3125 200.25 368 219.75 368 240 C 368 269.0625 356.75 295.625 338.5 315.5 L 293 270 C 299.6875 261.8125 304 251.4375 304 240 C 304 213.5 282.5 192 256 192 C 244.5625 192 234.1875 196.3125 226 203 L 193.5 170.5 C 213.375 164.375 234.1875 160 256 160 Z M 107 174.5 C 55.6875 206.0625 22.375 242.8125 20 245.5 L 10.5 256 L 20 266.5 C 24.125 271.125 118.875 374.8125 241 383 C 245.9375 383.5 250.9375 384 256 384 C 261.0625 384 266.0625 383.5 271 383 C 284.1875 382.125 297.0625 380.375 309.5 377.5 L 281 349 C 272.875 350.875 264.625 352 256 352 C 194.25 352 144 301.75 144 240 C 144 231.5 145.125 223.1875 147 215 Z M 116 207 C 113.4375 217.8125 112 228.8125 112 240 C 112 267.8125 119.8125 293.4375 133.5 315.5 C 96.875 294.5 68.875 269.875 54.5 256 C 66.4375 244.4375 87.9375 225.25 116 207 Z M 396 207 C 424.0625 225.25 445.5 244.4375 457.5 256 C 443.125 269.875 414.6875 295 378 316 C 391.75 293.9375 400 267.8125 400 240 C 400 228.8125 398.5625 217.75 396 207 Z " />
                                                    </g>
                                                </svg>
                                                <svg v-if="hidpassword == true" class="
                              w-[1.20rem]
                              h-[1.20rem]
                              text-gray-500
                              dark:text-gray-400
                            " xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                    width="512pt" height="512pt" viewBox="0 0 512 512" version="1.1">
                                                    <g id="surface1">
                                                        <path
                                                            style=" stroke:none;fill-rule:nonzero;fill:#959595;fill-opacity:1;"
                                                            d="M 256 128 C 122.625 128 20 245.5 20 245.5 L 10.5 256 L 20 266.5 C 20 266.5 113.5625 373.1875 238 383 C 243.9375 383.75 249.875 384 256 384 C 262.125 384 268.0625 383.75 274 383 C 398.4375 373.1875 492 266.5 492 266.5 L 501.5 256 L 492 245.5 C 492 245.5 389.375 128 256 128 Z M 256 160 C 291.25 160 323.75 169.625 352 182.5 C 362.1875 199.375 368 218.8125 368 240 C 368 297.8125 324.625 345.3125 268.5 351.5 C 268.1875 351.5625 267.8125 351.4375 267.5 351.5 C 263.6875 351.6875 259.875 352 256 352 C 251.75 352 247.625 351.75 243.5 351.5 C 187.375 345.3125 144 297.8125 144 240 C 144 219.125 149.625 199.6875 159.5 183 L 159 183 C 187.5 169.875 220.375 160 256 160 Z M 256 192 C 229.5 192 208 213.5 208 240 C 208 266.5 229.5 288 256 288 C 282.5 288 304 266.5 304 240 C 304 213.5 282.5 192 256 192 Z M 116 207 C 113.5 217.75 112 228.5625 112 240 C 112 268.0625 120 294.3125 134 316.5 C 93.6875 293.1875 65.6875 265.375 56.5 256 C 64.1875 248.125 85.625 227.25 116 207 Z M 396 207 C 426.375 227.25 447.8125 248.125 455.5 256 C 446.3125 265.375 418.3125 293.1875 378 316.5 C 392 294.3125 400 268.0625 400 240 C 400 228.5625 398.5 217.625 396 207 Z " />
                                                    </g>
                                                </svg>
                                            </button>
                                            <input v-model="form.password" :type="hidpassword ? 'text' : 'password'"
                                                required id="input-group-1"
                                                class=" bg-gray-200 border border-white  text-sm rounded-lg focus:ring-[#FF9900] focus:border-[#FF9900] block w-full p-2.5  placeholder-gray-400 focus:outline-none"
                                                :placeholder="$t('motdepasse')" />
                                        </div>
                                    </div>
                                    <div class="w-full flex mt-6">
                                        <button v-if="loading == false" class="
                          bg-[#FF9900]
                          rounded-lg
                          text-lg
                          hover:border-2
                          hover:border-[#FF9900]
                          hover:bg-transparent
                          hover:text-[#FF9900]
                          text-white
                          w-40
                          mx-auto
                          h-10
                          text-center
                        ">
                                            {{ $t('btnconnecter') }}
                                        </button>
                                        <div v-if="loading == true" class="
                          rounded-lg
                          flex
                          items-center
                          justify-center
                          border-[#FF9900]
                          border-2
                          text-white
                          w-40
                          mx-auto
                          h-10
                          text-center">
                                            <svg aria-hidden="true"
                                                class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-white fill-[#FF9900]"
                                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill" />
                                            </svg>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div @click="showHidLangue" v-if="hidlangue == true" class="w-full h-screen  z-30 flex fixed"></div>
        </div>
    </div>
</template>
    
<script>
export default {
    data() {
        return {
            form: {
                email: "",
                password: "",
            },
            formForget: {
                email: '',
                code: '',
                langue: ''
            },
            formNewPassword: {
                password: "",
                password_confirmation: ""
            },
            erreurs: '',
            loading: false,
            langue: '',
            user: {},
            hidlangue: false,
            hidpassword: false,
            hidForget: false,
            hidEnterEmailCode: false,
            hidEnterCode: false,
            code: '',
            errorEmail: '',
            errorcode: '',
            emailNotFind: '',
            loadingcode: false,
            HidEnterChangePassword: '',
            errorpassword: '',
            loadingChangePassword: '',
            userId: '',
            messageMdpChange: false,
            loadingnewcode: false,
            valideSend: false,
            loadConfirmeMail: false,
            email: '',
            errors: '',
            hidcode: false,
            erreurAlert: '',
            messageErreurAlert: '',
            successAlert: '',
            messageSuccessAlert: '',
            widthMessage:'',
        };
    },
    async mounted() {
        this.$store.commit('reset')
        if (localStorage.getItem('jwtToken')) {
            this.$router.push('/MesCommandes');
        }
        if (localStorage.getItem('langue') == null || localStorage.getItem('langue') == '' || localStorage.getItem('langue') == false) {
            localStorage.setItem('langue', 'fr')
        }

        if (localStorage.getItem('langue') != 'en') {
            this.$i18n.locale = 'fr'
        } else {
            this.$i18n.locale = 'en'
        }

        if (localStorage.getItem('langue')) {
            this.langue = localStorage.getItem('langue');
        }
        if (window.innerWidth < 768) {
            this.widthMessage = window.innerWidth * 90 / 100
        } else if(window.innerWidth >= 768 && window.innerWidth < 1280) {
            this.widthMessage = window.innerWidth * 40 / 100
        } else {
            this.widthMessage = window.innerWidth * 25 / 100
        }
    },
    methods: {
        async convertTextInGras(titre){
            // Expression régulière pour trouver les mots entre <>
            var regex = /<([^>]+)>/g;

            // Remplacez les mots entre <> par des versions en gras
            var newText = titre.replace(regex, function(match, mot) {
                return '<span class="font-bold text-black">' + mot + '</span>';
            });
            // Recuperer l'element du DOM et ajouter la nouvelle forme du texte 
            this.$nextTick(() => {
                document.getElementById(`slogan`).innerHTML = newText.trim()       
            })
        },
        async login() {
            this.loading = true;
            let encryptedForm = { ...this.form };
            for (let key in encryptedForm) {
                if (encryptedForm.hasOwnProperty(key)) {
                encryptedForm[key] = this.$crypto(encryptedForm[key]);
                }
            }
            await this.axios.post(this.requestHttp + 'login_caisse', encryptedForm).then(({ data }) => {
                localStorage.setItem('jwtToken', data.access_token.token)
                if(!data.user.relai){
                    this.alertError('relai not found',this.$i18n.messages[`${localStorage.getItem('langue')}`].relainotfound)
                }else{
                    if (window.history.state.back == null) {
                        this.$router.push('/MesCommandes');
                    } else {
                        this.$router.back()
                    }
                }
                window.Echo.options.auth.headers.Authorization = `Bearer ${data.access_token.token}`

            }).catch((error) => {
                this.alertError('erreur',error.response.data.message == 'access denied' ? this.$i18n.messages[`${localStorage.getItem('langue')}`].accessinterdit:  this.$i18n.messages[`${localStorage.getItem('langue')}`].motdepasseouemailincorrect)
                this.loading = false;
            });
        },
        verifyCode() {
            this.loadingcode = true
            this.axios.post(this.requestHttp + 'verify_code', { email: this.formForget.email, code: this.formForget.code }).then(() => {
                this.alertSuccess('code correct', this.$i18n.messages[`${localStorage.getItem('langue')}`].codecorrect)
                this.errorcode = 'code correct'
                this.hidcode = false;
                this.HidEnterChangePassword = true;
                this.loadingcode = false
                this.errorcode = ''
            }).catch(() => {
                this.loadingcode = false
                this.alertError('code incorrect', this.$i18n.messages[`${localStorage.getItem('langue')}`].errorcode)
                this.errorcode = 'incorrect'
            })
        },
        showHidLangue() {
            if (this.hidlangue == true) {
                this.hidlangue = false
            } else {
                this.hidlangue = true
                this.hidnotification = false
            }
        },
        changeLangue() {
            this.hidlangue = false
            localStorage.setItem('langue', this.langue)

            if (this.langue == 'fr') {
                this.langue = 'en'
                localStorage.setItem('langue', this.langue)
            } else {
                this.langue = 'fr'
                localStorage.setItem('langue', this.langue)
            }

            if (localStorage.getItem('langue') != 'en') {
                this.$i18n.locale = 'fr'
            } else {
                this.$i18n.locale = 'en'
            }
        },
        confirmEmail() {
            this.loadConfirmeMail = true
            this.formForget.langue = this.langue
            this.axios.post(this.requestHttp + 'send-email-password', this.formForget).then(({ data }) => {
                this.loadConfirmeMail = false
                this.hidEnterEmailCode = false
                this.hidcode = true
                this.erreurs = ''
                this.userId = data.id
            }).catch((error) => {
                    this.errors = error.response.data;
                    this.loadConfirmeMail = false;
                    if (error && error.response.data[0]) {
                        this.errors = error.response.data[0]
                        this.alertError(error.response.data[0].message, this.$i18n.messages[`${localStorage.getItem('langue')}`].emailnotexist)
                    }
                });
        },
        newCode() {
            this.loadingnewcode = true
            this.axios.post(this.requestHttp + 'send-email-password', this.formForget)
                .then(() => {
                    this.valideSend = true
                    setTimeout(() => {
                        this.valideSend = false
                        this.loadingnewcode = false
                    }, 5000);
                }).catch()
        },


        changePassword() {
            var passwd = /^(?=.*[!@#$%^&*])/
            if (this.formNewPassword.password.match(passwd)) {
                passwd = /^(?=.*[0-9])/
                if (this.formNewPassword.password.match(passwd)) {
                    if (this.formNewPassword.password != this.formNewPassword.password_confirmation) {
                        this.alertError('password no match', this.$i18n.messages[`${localStorage.getItem('langue')}`].mdpdifferentdemdpc)
                        this.erreurs = ''
                    } else {
                        if (this.formNewPassword.password.length < 8) {
                            this.alertError('password no 8', this.$i18n.messages[`${localStorage.getItem('langue')}`].mdpdinferieurahuit)
                            this.erreurs = ''
                        } else {
                            passwd = /^(?=.*[a-z])/
                            if (this.formNewPassword.password.match(passwd)) {
                                passwd = /^(?=.*[A-Z])/
                                if (this.formNewPassword.password[0].match(passwd)) {
                                    this.loadingChangePassword = true;
                                    this.axios.put(this.requestHttp + 'resetpassword/' + this.userId, this.formNewPassword).then(() => {
                                        this.hidForget = false;
                                        this.HidEnterChangePassword = false;
                                        this.messageMdpChange = true
                                        this.alertSuccess('mot de passe renitialise', this.$i18n.messages[`${localStorage.getItem('langue')}`].motdepasserenitialise)
                                    })
                                        .catch(error => {
                                            this.errors = error.response.data.errors[0];
                                            this.loading = false
                                        })
                                } else {
                                    this.alertError('uppercase password', this.$i18n.messages[`${localStorage.getItem('langue')}`].mdpmajuscule)
                                    this.erreurs = ''
                                }
                            } else {
                                this.alertError('erreur structure password', this.$i18n.messages[`${localStorage.getItem('langue')}`].errorstructurepasswordlowercase)
                            }
                        }
                    }
                } else {
                    this.alertError('erreur structure password', this.$i18n.messages[`${localStorage.getItem('langue')}`].errorstructurepasswordnumber)
                }
            } else {
                this.alertError('erreur structure password', this.$i18n.messages[`${localStorage.getItem('langue')}`].errorstructurepasswordcaractere)
            }
        },
        alertSuccess(title, message) {
            this.music = new Audio(
                "/music/notification.mp3"
            )
            this.music.autoplay = true
            this.successAlert = title,
                this.messageSuccessAlert = message,
                setTimeout(() => {
                    this.successAlert = ''
                }, 5000);
        },
        alertError(title, message) {
            this.music = new Audio(
                "/music/error.mp3"
            )
            this.music.autoplay = true
            this.erreurAlert = title
            this.messageErreurAlert = message
            setTimeout(() => {
                this.erreurAlert = ''
            }, 5000);
        }
    },
    computed: {
        requestHttp() {
            return this.$store.state.api
        }
    }
}
</script>
    
<style></style>